<template>
  <sf-modal v-if="showModal" size="xs" @close="closeModal">
    <template #title>
      {{
        I18n.t('reconciliation_review.confirm_unreview_template_modal.title')
      }}
    </template>
    <template #body>
      <div
        v-dompurify-html="
          I18n.t(
            'reconciliation_review.confirm_unreview_template_modal.text1',
            { reviewers: reviewers }
          )
        "
        class="center"
      ></div>
    </template>

    <template #messages-bottom>
      <sf-modal-message variant="warning">
        {{
          I18n.t('reconciliation_review.confirm_unreview_template_modal.text2')
        }}
      </sf-modal-message>
    </template>

    <template #footer>
      <div
        v-if="submitting"
        class="sf-spinner sf-spinner-primary sf-spinner-s sf-modal-xs"
      ></div>
      <a
        v-if="!submitting"
        class="sf-btn"
        data-heap="remove-reviews-cancel"
        @click="closeModal"
      >
        {{ I18n.t('common.cancel') }}
      </a>
      <a
        v-if="!submitting"
        class="sf-btn sf-btn-success"
        data-heap="remove-reviews-confirm"
        @click="confirm"
      >
        {{
          I18n.t(
            'reconciliation_review.confirm_unreview_template_modal.confirm_button'
          )
        }}
      </a>
    </template>
  </sf-modal>
</template>

<script type="text/javascript">
import { SfModal, SfModalMessage } from '@app/shared/vue/components/sf-modal'

export default {
  name: 'ConfirmUnreviewTemplateModal',
  components: { SfModal, SfModalMessage },
  data() {
    return {
      showModal: true,
      reviewers: '',
      submitting: false,
    }
  },
  methods: {
    openModal({ onConfirm, reviewers, keepOpenAfterConfirmation }) {
      this.showModal = true
      this.onConfirm = onConfirm
      this.reviewers = reviewers
      this.keepOpenAfterConfirmation = keepOpenAfterConfirmation
      this.hideOtherOpenModal()
    },
    closeModal() {
      this.showModal = false
    },
    confirm() {
      this.onConfirm()

      if (this.keepOpenAfterConfirmation === true) {
        this.submitting = true
      } else {
        this.closeModal()
        // We show it again because the attaching files to templates modal can
        // render errors
        this.showPreviouslyHiddenModal()
      }
    },
    hideOtherOpenModal() {
      this.previouslyHiddenModal =
        document.querySelector('body > .sf-modal') || // Attaching files to templates
        document.querySelector(".sf-modal[data-show='true']") // Account setting edit modal

      if (this.previouslyHiddenModal) {
        // This is a workaround to hide open modals outside of the modal portal
        // E.g.:
        // - Attaching files to templates
        this.previouslyHiddenModal.classList.add('hidden')
      } else {
        this.previouslyHiddenModalPortalModalIdentifier =
          window.modalCitizen.closeModalPortal()
      }
    },
    // We open the previously hidden modal after this modal is closed because
    // it can render errors after it finish its action.
    showPreviouslyHiddenModal() {
      if (this.previouslyHiddenModal) {
        this.previouslyHiddenModal.classList.remove('hidden')
      } else if (this.previouslyHiddenModalPortalModalIdentifier) {
        window.modalCitizen.openModalPortal(
          this.previouslyHiddenModalPortalModalIdentifier
        )
      }
    },
  },
}
</script>
